import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';

import Checkbox from '../../common/Checkbox';
import Icon, { GLYPHS } from '../../common/icon';
import SelectAllFiltersOption from '../appointments/barbersFilter/selectAllFiltersOption';

class ReportsFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { isActive: false };
  }

  toggleDropdown = (e) => {
    e.preventDefault();
    this.setState({ isActive: !this.state.isActive });
  };

  handleClickOutside = () => {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    }
  };

  updateViewed = (filter) => {
    return this.props.updateStatusViewed(filter);
  };

  render() {
    const { filters, currentView, allChecked, showSelectAll, automationIdPart } = this.props;
    const filtersList = map(filters, filter => (
      <div key={filter.id}>
        <Checkbox
          checked={filter.checked}
          onChange={() => this.updateViewed(filter)}
          automationId={`filter:${automationIdPart}:${filter.title}`}
        >
          {filter.title}
        </Checkbox>
      </div>
    ));

    const dropdownBodyClass = classNames('c-tooltip c-tooltip--barbers u-p0', {
      'is-active': this.state.isActive,
    });

    const dropdownTriggerClass = classNames('c-dropdown-new', {
      'is-active': this.state.isActive,
    });

    const containerClass = classNames({
      'u-visible-for-medium-and-up': currentView !== 'list',
      'o-flexbox__item u-ml--': currentView !== 'list',
    });

    return (
      <div className={`reports-filter-dropdown-container ${containerClass}`}>
        <div className="has-tooltip">
          <a
            className={dropdownTriggerClass}
            onClick={this.toggleDropdown}
            data-automation-id={`filter:${automationIdPart}`}
          >
            {this.props.title}
            <Icon glyph={GLYPHS.arrow} className="c-dropdown-icon" />
          </a>
          <div className={dropdownBodyClass}>
            <ul className="c-separator-list">
              <li className="c-separator-list__item">
                <SelectAllFiltersOption
                  display-if={showSelectAll}
                  onChange={this.updateViewed}
                  checked={allChecked}
                  automationId={`filter:${automationIdPart}:selectAll`}
                />
                {filtersList}
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

ReportsFilter.propTypes = {
  title: PropTypes.string.isRequired,
  updateStatusViewed: PropTypes.func.isRequired,
  currentView: PropTypes.string,
  filters: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  allChecked: PropTypes.bool,
  showSelectAll: PropTypes.bool,
  automationIdPart: PropTypes.string,
};

ReportsFilter.defaultProps = {
  currentView: '',
  allChecked: false,
  showSelectAll: false,
  automationIdPart: null,
};

export default onClickOutside(ReportsFilter);
